module.exports = __webpack_public_path__ + "static/image/service/pc/bmart@3x.jpg?840b27a3";